import React, { useRef } from "react";
import { Bg, Container, FirstBox, SecondBox, TextBox, Wrapper } from "./style";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
import { useTranslation } from "react-i18next";
const Com5 = () => {
  const ref1 = useRef();
  const ref2 = useRef();
  useScrollFadeIn(ref1, ref2);

  const { t } = useTranslation("landing");
  return (
    <Wrapper>
      <Bg>
        <img
          loading="lazy"
          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/4d79abe5Landing_7.png"
          alt=""
        />
        <img
          loading="lazy"
          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/fd1d177fLanding_8.png"
          alt=""
        />
      </Bg>
      <Container>
        <FirstBox>
          <img
            loading="lazy"
            src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/fd5ab675Landing_9.png"
            alt=""
          />
          <TextBox ref={ref1} className="fade-in">
            <span>{t("5-1")}</span>
            <span>
              <span>{t("5-2")}</span>
              <span>
                {t("5-3")} {t("5-4")}
              </span>
              <span></span>
            </span>
          </TextBox>
        </FirstBox>
        <SecondBox>
          <TextBox ref={ref2} className="fade-in">
            <span>{t("5-5")}</span>
            <span>
              <span>{t("5-6")}</span>
              <span>{t("5-7")}</span>
              <span>{t("5-8")}</span>
            </span>
          </TextBox>
          <img
            loading="lazy"
            src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/fed38eb7Landing_10.png"
            alt=""
          />
        </SecondBox>
      </Container>
    </Wrapper>
  );
};

export default Com5;
